import type { ReactNode } from "react";

export function GreenfieldBootShell({
  message = "Loading Studio",
  children,
}: {
  readonly message?: string;
  readonly children?: ReactNode;
}) {
  return (
    <div className="enrein-workspace-v1" data-greenfield-boot="true">
      <a className="ws-skip-link" href="#greenfield-main">
        Skip to content
      </a>
      <main id="greenfield-main" className="ws-card" style={{ margin: "24px auto", maxWidth: 480 }}>
        <p className="ws-muted">{message}</p>
        {children}
      </main>
    </div>
  );
}
